import { useState, useEffect, useRef } from 'react';
import { shallowEqual, useSelector, useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { useAppContext } from '../../Lib/contextLib';
import { getVideo, GetUserVideo } from '../../s3Func/s3Download';
import { API, Auth } from 'aws-amplify';
import PopUp from '../../Popup/logoutPopup';
import { CloudfrontVideoFormat } from '../../videos/CloudfrontVideoFormat';
import './Module18World.css';
import '../../Animations.css';
import loading from './../../loading-gif-png-5.gif';
import Draggable from 'react-draggable';

import Learn from '../../Learn/Learn';
import Practice from '../../Unit4/Module18/Egg/EggPractice';
import PracticeRecording from '../../Unit4/Practice/PracticeRecording';
import SingingTime from '../../SingingTime/SingingTime';
import Celebrate from '../../Celebrate/Celebrate';
import Surprise from '../../SurpriseVideo/surprise';
import FollowTheBeatModule8 from '../../FollowTheBeat/FollowTheBeatModule8.js';
import presentSound from './../../Unit1/Module1/assets/ta_da_gift.mp3';

const Module18World = () => {
  const [clientHeight, setVh] = useState(window.innerHeight);
  const [clientWidth, setVw] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => {
      setVh(window.innerHeight);
      setVw(window.innerWidth);
    };
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, [clientHeight, clientWidth]);
  const { userHasAuthenticated } = useAppContext();
  const dispatch = useDispatch();
  const { module18 } = useSelector((state) => state.module18, shallowEqual);
  const { login } = useSelector((state) => state.loginReducer, shallowEqual);
  const [isOpen, setIsOpen] = useState(false);
  const navigate = useNavigate();
  const generateImageUrl = (baseUrl) => login.cloudFront + baseUrl + login.cookie;

  const background = generateImageUrl('images/Module18Images/Unit4_Mod3BG_Final.png');
  const animal = generateImageUrl('images/Module3Images/Lizard+closing+still+image.gif');
  const progressbar0 = generateImageUrl('images/Module3Images/LizTongue_Empty_100819.svg');
  const progressbar1 = generateImageUrl('images/Module3Images/LizTongue_1out3_100819.svg');
  const progressbar2 = generateImageUrl('images/Module3Images/LizTongue_2out3_100819.svg');
  const progressbar3 = generateImageUrl('images/Module3Images/LizTongue_2out3_100819.svg');
  const progressbarCompleted = generateImageUrl('images/Module3Images/LizTongue_Complete_100819.svg');
  const coinPick = generateImageUrl('images/Images/AwesomeCoin.png');
  const coinBar = generateImageUrl('images/Images/Coin+Counter.png');
  const journeyImage = generateImageUrl('images/Module1Images/bluejourneymap.svg');
  const logoutBtn = generateImageUrl('images/Module1Images/Logout.png');
  const reviewBtn = generateImageUrl('images/Module1Images/Button_Review.png');
  const rewardBtn = generateImageUrl('images/Module1Images/Button_Reward_3x.png')
  const celebrateBtn = generateImageUrl('images/Module1Images/Button_Celebrate.png');
  const learnBtn = generateImageUrl('images/Module1Images/Button_Learn.png');
  const practiceBtn = generateImageUrl('images/Module1Images/Button_Practice.png');
  const ftbBtn = generateImageUrl('images/Images/Button_FTB.png');
  const fly = generateImageUrl('images/Module3Images/Fly.png');
  const LongNeckGreen = generateImageUrl('images/Module8Images/DailyReward_DinoLongNeck_Green.png');
  const LongNeckRed = generateImageUrl('images/Module8Images/DailyReward_DinoLongNeck_Red.png');
  const PottedCactusBarrel = generateImageUrl('images/Module18Images/PottedCactusBarrel.png');
  const PottedCactusPrickly = generateImageUrl('images/Module18Images/PottedCactusPrickly.png');
  const DinoFlyingGreen = generateImageUrl('images/Module18Images/DinoFlyingGreen.png');
  const DinoFlyingPurple = generateImageUrl('images/Module18Images/DinoFlyingPurple.png');
  const BackpackGreen = generateImageUrl('images/Module18Images/BackpackGreen.png');
  const BackpackPurple = generateImageUrl('images/Module18Images/BackpackPurple.png');
  const StegoGreen = generateImageUrl('images/Module18Images/StegoGreen.png');
  const StegoBlue = generateImageUrl('images/Module18Images/StegoBlue.png');
  const FossilSkull = generateImageUrl('images/Module18Images/FossilSkull.png');
  const FossilArm = generateImageUrl('images/Module18Images/FossilArm.png');
  const Hat = generateImageUrl('images/Module18Images/Hat.png');
  const Bandanna = generateImageUrl('images/Module18Images/Bandanna.png');
  const RaptorLight = generateImageUrl('images/Module18Images/RaptorLight.png');
  const RaptorDark = generateImageUrl('images/Module18Images/RaptorDark.png');
  const LizardBandana = generateImageUrl('images/Module18Images/LizardBandana.png');
  const LizardVest = generateImageUrl('images/Module18Images/LizardVest.png');
  const greenCheck = generateImageUrl('images/Module1Images/GreenCheck-Button.png');
  const SingingTimeIcon = generateImageUrl('images/Module1Images/Button_SingingTime.png');
  const AfterCelebrateVideo9 = 'appfiles/resolve_conflict/closing.mp4';
  const present = generateImageUrl('images/Images/Gift.png');

  const [reviewIcon, setReviewIcon] = useState(false);
  const [keyIcon, setKeyIcon] = useState(false);
  const [coinIcon, setCoinIcon] = useState(false);
  const [presentIcon, setPresentIcon] = useState(false);
  const [rewardOption1, setRewardOption1] = useState(null);
  const [rewardOption2, setRewardOption2] = useState(null);
  const [displayReward, setDisplayReward] = useState(false);

  const [displayLearn, setDisplayLearn] = useState(false);
  const [displayPractice, setDisplayPractice] = useState(false);
  const [displayDay4Practice, setDisplayDay4Practice] = useState(false);
  const [displaySingingTime, setDisplaySingingTime] = useState(false);
  const [displayCelebrate, setDisplayCelebrate] = useState(false);
  const [displaybody, setDisplayBody] = useState(true);
  const [displayGreenButton, setdisplayGreenButton] = useState(false);
  const [learn, setLearn] = useState('');
  const [practice, setPractice] = useState('');
  const [singTime, setSingTime] = useState('');
  const [celebrate, setCelebrate] = useState('');
  const firstUpdate = useRef(true);
  const coinUpdate = useRef(true);
  const [displayIntroVideo, setDisplayIntroVideo] = useState(false);
  const [introVideo, setIntroVideo] = useState('');
  const [displaySurprise, setDisplaySurprise] = useState(false);
  const [surpriseVideo, setSurpriseVideo] = useState('');
  const [displayVoice, setDisplayVoice] = useState(false);
  const [animalVoice, setAnimalVoice] = useState('');
  const [prize, setPrize] = useState(false);
  const [disPlayPrize, setDisplayPrize] = useState(false);

  const keys5 = [
    progressbar0,
    progressbar1,
    progressbar2,
    progressbar2,
    progressbar3,
    progressbarCompleted,
  ];
  const keys4 = [
    progressbar0,
    progressbar1,
    progressbar2,
    progressbar3,
    progressbarCompleted,
  ];

  const [touchButton, setTouchButton] = useState(false);
  const [checkSound, setCheckSound] = useState(false);
  const [buttonSound, setButtonSound] = useState(false);
  const [rewardsFound, setRewardsFound] = useState(false);
  const [coinAnimationState, setCoinAnimationState] = useState('bounceIcons');
  const [coinAudio, setCoinAudio] = useState(false);

  const [specialMessage, setSpecialMessage] = useState('');
  const [watchConversation, setWatchConversation] = useState('');
  const [amazingJob, setAmazingJob] = useState('');

  const [practiceIntro, setPracticeIntro] = useState('');
  const [learnIntro, setLearnIntro] = useState('');
  const [ftbIntro, setFtbIntro] = useState('');
  const [celebrateIntro, setCelebrateIntro] = useState('');
  const [checkStep, setCheckStep] = useState('');
  const [rewardAnimationState, setRewardAnimationState] = useState('');
  const [showAnimal, setShowAnimal] = useState(false);
  const [animalState, setAnimalState] = useState('');
  const [showReward, setShowReward] = useState(false);

  const [ftbMusic, setFTBMusic] = useState('');
  const [ftbInstruction, setFTBInstruction] = useState('');
  const [ftbInstructionGIF, setFTBInstructionGIF] = useState('');
  const [ftbCount, setFTBCount] = useState('');
  const [ftbTutorial1, setFTBTutorial1] = useState('');
  const [ftbTutorial1_2, setFTBTutorial1_2] = useState('');
  const [ftbTutorial2, setFTBTutorial2] = useState('');
  const [ftbWT, setFTBWalkThrough] = useState('');

  const [showFly, setShowFly] = useState(false);
  const [lizardTongue, setLizardTongue] = useState('');
  const [bugSound, setBugSound] = useState(false);
  const [lizardTongueAudio, setLizardTongueAudio] = useState('');
  const [playLizardClose, setPlayLizardClose] = useState(false);
  const [animalClose, setAnimalClose] = useState('');
  const [animalCloseAudio, setAnimalCloseAudio] = useState('');
  const [displayFTB, setDisplayFTB] = useState(false);
  const [audioReady, setAudioReady] = useState(false);
  const [awesomeJob, setAwesomeJob] = useState('');
  const influencers = [
    login.influencerid,
    login.influencerid1,
    login.influencerid2,
    login.influencerid3,
    login.influencerid4,
  ];

  function sleep(ms) {
    return new Promise((resolve) => setTimeout(resolve, ms));
  }

  function getGifs() {
    setAwesomeJob(getVideo('appfiles/ask/ask_awesome_job.mp3', login));

    setLizardTongue(getVideo('appfiles/expressions/lizard_fly.gif', login));
    setSpecialMessage(getVideo('appfiles/ask/ask_special_message.gif', login));
    setWatchConversation(getVideo('appfiles/ask/ask_conversation.gif', login));
    setAmazingJob(getVideo('appfiles/ask/Ask Awesome Job.gif', login));
    setPracticeIntro(getVideo('appfiles/ask/ask_practice_intro.gif', login));
    setLizardTongueAudio(getVideo('appfiles/expressions/expressions_fly_catch.mp3', login));
    setLearnIntro(getVideo('appfiles/ask/ask_learn_intro.gif', login));
    setFtbIntro(getVideo('appfiles/ask/ask_ftb_intro.gif', login));
    setCelebrateIntro(getVideo('appfiles/ask/ask_celebrate_intro.gif', login));
    setAnimalClose(getVideo('appfiles/ask/ask_closing.gif', login));
    setAnimalCloseAudio(getVideo('appfiles/resolve_conflict/resolve_conflict_day_finished.mp3', login));
    setFTBInstruction(getVideo('appfiles/resolve_conflict/resolve_conflict_ftb_instructions.mp3', login));
    setFTBInstructionGIF(getVideo('appfiles/ask/ask_lizard_ftb_instructions.gif', login));
    setFTBMusic(getVideo('appfiles/ask/ask_ftb_audio.m4a', login));
    setFTBCount(getVideo('appfiles/ask/countingLizard.gif', login));

    if (!module18.unlockedDays.day2) {
      setFTBTutorial1(getVideo('appfiles/resolve_conflict/ftb_walkthrough_touch_right_shoulders.mp3', login));
      setFTBTutorial1_2(getVideo('appfiles/resolve_conflict/ftb_walkthrough_touch_left_shoulders.mp3', login));
      setFTBTutorial2(getVideo('appfiles/manners/ftb_walkthrough_together.mp3', login));
      setFTBWalkThrough(getVideo('appfiles/ask/ftb_walkthrough_audio.mp3', login));
    }

  }

  useEffect(() => {
    getGifs();
  }, []);

  const createGameDetails = (flag, reward, coin) => {
    const game_detail = module18.game_details;
    if (flag) {
      const flags = { flag, lastUpdated: new Date().toJSON() };
      game_detail.moduleFlags.psuh(flags);
    }
    if (coin >= 0) {
      game_detail.tokens_earned = coin;
    }
    if (reward) {
      const dailyRewards = [];
      for (const key in module18.rewards) {
        if (module18.rewards[key].unlocked === true) {
          const rewards = {
            type: key,
            x_multiplier: module18.rewards[key].x,
            y_multiplier: module18.rewards[key].y,
          };
          dailyRewards.push(rewards);
        }
      }
      game_detail.dailyRewards = dailyRewards;
    }
    dispatch({ type: 'MODULE18_SET_GameDetials', payload: game_detail });
  };

  const updateProgress = (async () => {
		const payload = {
			body: {
				id: login.studentid,
				module: "ResolveConflict",
				day_completed: module18.currentday,
				time_completed: new Date().toDateString(),
			},
		}
		await API.put('TIR', '/v3/student/progress', payload)
		.then((response) => {
		})
		.catch((error) => {
		});
	})

  const updateDB = async () => {
    const myInit = {
      body: {
        id: module18.moduleID,
        day_completed: module18.day_completed,
        step_completed: module18.stepCompleted,
        game_details: JSON.stringify(module18.game_details),
      },
    };
    await API.put('TIR', '/v3/student/module', myInit)
      .then((response) => {
        if (displayGreenButton) {
          setAnimalVoice(null);
          setShowAnimal(true);
          setPlayLizardClose(true);
          setAnimalState(animalClose);
          setdisplayGreenButton(false);
          setDisplayReward(false);
        }
      })
      .catch((error) => {
        console.log(error);
        if (
          module18.stepCompleted === 'notstarted' ||
          module18.stepCompleted === 'learn' ||
          module18.stepCompleted === 'practice' ||
          module18.stepCompleted === 'celebrate' ||
          module18.stepCompleted === 'followthebeat'
        ) {
          window.alert('Connection is lost. Please login again.');
          dispatch({ type: 'CLEAR' });
          Auth.signOut();
          navigate('/');
        }
      });
      const myInit2 = {
        body: {
          id: login.studentid,
          current_module: 'ResolveConflict',
        },
      };
      await API.put('TIR', '/v3/student', myInit2)
      .then((response) => {
      })
      .catch((error) => {
      });
  };

  useEffect(() => {
    if (firstUpdate.current) {
      firstUpdate.current = false;
    } else {
      if(login.grade !== "Teacher Mode" && login.grade !== 'Free Play'){
        updateDB();
      }
    }
  }, [module18.stepCompleted, module18.day_completed]); // delete

    useEffect(() => {
      if((module18.reviewIcon === true || login.grade === "Teacher Mode") && module18.sectionCompleted === 4 ) {
          updateProgress();
          module18.sectionCompleted = 0;
      }
    }, [module18.sectionCompleted])

  useEffect(() => {
    if (module18.coins >= 100) {
      setPrize(true);
    }
    if (coinUpdate.current) {
      coinUpdate.current = false;
    } else {
      createGameDetails(false, false, module18.coins);
      updateDB();
    }
  }, [module18.coins]);

  const togglePopup = () => {
    setIsOpen(!isOpen);
  };

  const coinAnimation = () => {
    setCoinAnimationState('coinAnimation');
    setCoinAudio(true);
  };

  useEffect(() => {
    if (module18.currentday <= module18.day_completed || login.grade === "Teacher Mode" || login.grade === "Free Play") {
      if(login.grade === "Teacher Mode" || login.grade === "Free Play"){
        setShowReward(true)
      }
      dispatch({ type: 'MODULE18_TOGGLE_REVIEW_ICON', payload: true });
      dispatch({ type: 'MODULE18_SET_KEY', payload: 4 });
      if (module18.currentday === 4 || module18.currentday === 8) {
        dispatch({ type: 'MODULE18_SET_KEY', payload: 5 });
      }
    } else {
      if (module18.stepCompleted === checkStep) {
        setCoinIcon(true);
      }
      dispatch({ type: 'MODULE18_TOGGLE_REVIEW_ICON', payload: false });
      if (module18.currentday === 4 && module18.day_completed === 3) {
        if (module18.stepCompleted === 'notstarted') {
          dispatch({ type: 'MODULE18_SET_KEY', payload: 0 });

        } else if (module18.stepCompleted === 'singingtime') {
          dispatch({ type: 'MODULE18_SET_KEY', payload: 1 });

        } else if (module18.stepCompleted === 'learn') {
          dispatch({ type: 'MODULE18_SET_KEY', payload: 2 });

        } else if (module18.stepCompleted === 'practice') {
          dispatch({ type: 'MODULE18_SET_KEY', payload: 3 });

        } else if (module18.stepCompleted === 'followthebeat') {
          dispatch({ type: 'MODULE18_SET_KEY', payload: 4 });
        } else if (module18.stepCompleted === 'celebrate') {
          setKeyIcon(true);
          dispatch({ type: 'MODULE18_SET_KEY', payload: 5 });
        }
        playButtonAudio();
      } else {
        if (module18.stepCompleted === 'notstarted') {
          dispatch({ type: 'MODULE18_SET_KEY', payload: 0 });

        } else if (module18.stepCompleted === 'learn') {
          dispatch({ type: 'MODULE18_SET_KEY', payload: 1 });

        } else if (module18.stepCompleted === 'practice') {
          dispatch({ type: 'MODULE18_SET_KEY', payload: 2 });
  
        } else if (module18.stepCompleted === 'followthebeat') {
          dispatch({ type: 'MODULE18_SET_KEY', payload: 3 });

        } else if (module18.stepCompleted === 'celebrate') {
          if (module18.currentday === 8 && module18.day_completed === 7) {
            dispatch({ type: 'MODULE18_SET_KEY', payload: 4 });
            setPresentIcon(true);
          } else {
            setKeyIcon(true);
            dispatch({ type: 'MODULE18_SET_KEY', payload: 4 });
          }
        } else if (module18.stepCompleted === 'surprise') {
          dispatch({ type: 'MODULE18_SET_KEY', payload: 5 });
          setKeyIcon(true);
        }
        playButtonAudio();
      }
    }
  }, [module18.stepCompleted]);

  let [displayGreenCheck, setDisplayGreenCheck] = useState(false);
  let [dropZone, setDropZone] = useState(false);
  let [displayRewardVideo, setDisplayRewardVideo] = useState(false);
  let [rewardVideo, setRewardVideo] = useState('');

  const selectReward = () => {
    return (
      <>
        <div className='rewards' id ='rewardList'>
          <div className='circle' id='rewardItemLeft2'>
            <img
              src={rewardOption1}
              alt=''
              onClick={() => {
                setTouchButton(true);
                dispatch({
                  type: `MODULE18_SET_REWARD${module18.currentday}1`,
                  payload: true,
                });
                dispatch({
                  type: `MODULE18_SET_REWARD${module18.currentday}2`,
                  payload: false,
                });
                document.getElementById('rewardItemLeft2').style.borderColor =
                  'yellow';
                document.getElementById('rewardItemRight2').style.borderColor =
                  'white';
                setTouchButton(true);
                setDisplayGreenCheck(true);
              }}
            />
          </div>
          <div className='circle' id='rewardItemRight2'>
            <img
              src={rewardOption2}
              alt=''
              onClick={() => {
                setTouchButton(true);
                dispatch({
                  type: `MODULE18_SET_REWARD${module18.currentday}2`,
                  payload: true,
                });
                dispatch({
                  type: `MODULE18_SET_REWARD${module18.currentday}1`,
                  payload: false,
                });
                document.getElementById('rewardItemRight2').style.borderColor =
                  'yellow';
                document.getElementById('rewardItemLeft2').style.borderColor =
                  'white';
                setTouchButton(true);
                setDisplayGreenCheck(true);
              }}
            />
          </div>
        </div>
        <div className='greenCheckDiv'>
            {displayGreenCheck && <img className='greenCheck' src={greenCheck} alt="" onClick={() => { 
                document.getElementById("rewardList").style.zIndex = 1;
                setCheckSound(true);
                setDropZone(true);
                setDisplayGreenCheck(false);
                setdisplayGreenButton(true);
            }}/>}
        </div>
        {displayRewardVideo && (
          <video id='rewardVideo'
              autoPlay
              onEnded={() => {
                updateProgress();
                sleep(500).then(() => {
                  createGameDetails(false, true);
                  if(login.grade === "Teacher Mode" || login.grade === "Free Play"){
                    updateDB();
                  }
                  dispatch({
                    type: `MODULE18_SET_DAY_UNLOCK${module18.currentday + 1}`,
                    payload: true,
                  });
                  dispatch({
                    type: 'MODULE18_SET_dayCompleted',
                    payload: module18.currentday === 8 ? 9 : module18.currentday,
                  });
                  dispatch({
                    type: 'MODULE18_SET_stepCompleted',
                    payload: 'notstarted',
                  });
                });
              }}
              onError={() => {
                updateProgress();
                sleep(500).then(() => {
                  createGameDetails(false, true);
                  dispatch({
                    type: `MODULE18_SET_DAY_UNLOCK${module18.currentday + 1}`,
                    payload: true,
                  });
                  dispatch({
                    type: 'MODULE18_SET_dayCompleted',
                    payload: module18.currentday === 8 ? 9 : module18.currentday,
                  });
                  dispatch({
                    type: 'MODULE18_SET_stepCompleted',
                    payload: 'notstarted',
                  });
                });
              }}
              playsInline
            >
              <source src={rewardVideo} type='video/mp4'></source>
          </video>
        )}
        {dropZone && <div class="area">
            <div id="dropZone">Drag and drop your item</div>
        </div>}
        <div className='greenCheckDiv'>
          {displayGreenButton && (
            <img
              className='greenCheck'
              src={greenCheck}
              alt=''
              onClick={() => {
                setCheckSound(true);
                setDropZone(false);
                let name = '';
                switch (module18.currentday){
                  case 1:
                    if (document.getElementById('rewardItemLeft2').style.borderColor === 'yellow'){
                      name = 'media/Module18/Unit4_Mod3_DailyReward_Outfit 1.mp4'
                    }
                    else{
                      name = 'media/Module18/Unit4_Mod3_DailyReward_Outfit 2.mp4'
                    }
                    break;
                  case 2:
                    if (document.getElementById('rewardItemLeft2').style.borderColor === 'yellow'){
                      name = 'media/Module18/Unit4_Mod3_DailyReward_Cactus 1_1.mp4'
                    }
                    else{
                      name = 'media/Module18/Unit4_Mod3_DailyReward_Cactus 2.mp4'
                    }
                    break;
                  case 3:
                    if (document.getElementById('rewardItemLeft2').style.borderColor === 'yellow'){
                      name = 'media/Module18/Unit4_Mod3_DailyReward_Flying Dino 1.mp4'
                    }
                    else{
                      name = 'media/Module18/Unit4_Mod3_DailyReward_Flying Dino 2.mp4'
                    }
                    break;
                  case 4:
                    if (document.getElementById('rewardItemLeft2').style.borderColor === 'yellow'){
                      name = 'media/Module18/Unit4_Mod3_DailyReward_Bus 1.mp4'
                    }
                    else{
                      name = 'media/Module18/Unit4_Mod3_DailyReward_Bus 2.mp4'
                    }
                    break;
                  case 5:
                    if (document.getElementById('rewardItemLeft2').style.borderColor === 'yellow'){
                      name = 'media/Module18/Unit4_Mod3_DailyReward_GiftShop 2.mp4'
                    }
                    else{
                      name = 'media/Module18/Unit4_Mod3_DailyReward_GiftShop 1.mp4'
                    }
                    break;
                  case 6:
                    if (document.getElementById('rewardItemLeft2').style.borderColor === 'yellow'){
                      name = 'media/Module18/Unit4_Mod3_DailyReward_Fossil 1.mp4'
                    }
                    else{
                      name = 'media/Module18/Unit4_Mod3_DailyReward_Fossil 2.mp4'
                    }
                    break;
                  case 7:
                    if (document.getElementById('rewardItemLeft2').style.borderColor === 'yellow'){
                      name = 'media/Module18/Unit4_Mod3_MeatEaters.mp4'
                    }
                    else{
                      name = 'media/Module18/Unit4_Mod3_MeatEaters 2.mp4'
                    }
                    break;
                  case 8:
                    if (document.getElementById('rewardItemLeft2').style.borderColor === 'yellow'){
                      name = 'media/Module18/Unit4_Mod3_DailyReward_Plant Eater 2.mp4'
                    }
                    else{
                      name = 'media/Module18/Unit4_Mod3_DailyReward_Plant Eater 1.mp4'
                    }
                    break;
                }
                setRewardVideo(generateImageUrl(name))
                document.getElementById('rewardItemLeft2').style.display = 'none'
                document.getElementById('rewardItemRight2').style.display = 'none'
                setDisplayRewardVideo(true);
              }}
            />
          )}
        </div>
      </>
    );
  };

  const openPrize = () => {
    return (
      <>
        <div className='rewards' id ='rewardList'>
          <div className='circle' id='rewardItemLeft'>
            <img
              src={LizardBandana}
              alt=''
              onClick={() => {
                dispatch({ type: `MODULE18_SET_PRIZE1`, payload: true });
                dispatch({ type: `MODULE18_SET_PRIZE2`, payload: false });
                document.getElementById('rewardItemLeft').style.borderColor =
                  'yellow';
                document.getElementById('rewardItemRight').style.borderColor =
                  'white';
                setTouchButton(true);
                setDisplayGreenCheck(true);
              }}
            />
          </div>
          <div className='circle' id='rewardItemRight'>
            <img
              src={LizardVest}
              alt=''
              onClick={() => {
                dispatch({ type: `MODULE18_SET_PRIZE2`, payload: true });
                dispatch({ type: `MODULE18_SET_PRIZE1`, payload: false });
                document.getElementById('rewardItemRight').style.borderColor =
                  'yellow';
                document.getElementById('rewardItemLeft').style.borderColor =
                  'white';
                setTouchButton(true);
                setDisplayGreenCheck(true);
              }}
            />
          </div>
        </div>
        <div className='greenCheckDiv'>
            {displayGreenCheck && <img className='greenCheck' src={greenCheck} alt="" onClick={() => { 
                document.getElementById("rewardList").style.zIndex = 1;
                setCheckSound(true);
                setDropZone(true);
                setDisplayGreenCheck(false);
                setdisplayGreenButton(true);
            }}/>}
        </div>
        {displayRewardVideo && (
          <video id='rewardVideo'
              autoPlay
              onEnded={() => {
                setDisplayPrize(false);
                sleep(500).then(() => {
                  setdisplayGreenButton(false);
                  createGameDetails(false, true);
                  dispatch({
                    type: 'MODULE18_SET_COIN',
                    payload: module18.coins - 100,
                  });
                  setDisplayRewardVideo(false);
                });
              }}
              onError={() => {
                setDisplayPrize(false);
                sleep(500).then(() => {
                  setdisplayGreenButton(false);
                  createGameDetails(false, true);
                  dispatch({
                    type: 'MODULE18_SET_COIN',
                    payload: module18.coins - 100,
                  });
                  setDisplayRewardVideo(false);
                });
              }}
              playsInline
            >
              <source src={rewardVideo} type='video/mp4'></source>
          </video>
        )}
        {dropZone && <div class="area">
            <div id="dropZone">Drag and drop your item</div>
        </div>}
        <div className='greenCheckDiv'>
          {displayGreenButton && (
            <img
              className='greenCheck'
              src={greenCheck}
              alt=''
              onClick={() => {
                setCheckSound(true);
                setDropZone(false);
                if (document.getElementById('rewardItemLeft').style.borderColor === 'yellow'){
                  setRewardVideo(generateImageUrl('media/Module18/Unit4_Mod3_SpecialReward_Dance 1.mp4'))
                }
                else{
                  setRewardVideo(generateImageUrl('media/Module18/Unit4_Mod3_SpecialRewards_Dance 2.mp4'))
                }
                document.getElementById('rewardItemLeft').style.display = 'none'
                document.getElementById('rewardItemRight').style.display = 'none'
                setDisplayRewardVideo(true);
              }}
            />
          )}
        </div>
      </>
    );
  };

  useEffect(() => {
    switch (module18.currentday) {
      case 1:
        setRewardOption1(Bandanna);
        setRewardOption2(Hat);
        break;
      case 2:
        setRewardOption1(PottedCactusBarrel);
        setRewardOption2(PottedCactusPrickly);
        break;
      case 3:
        setRewardOption1(DinoFlyingGreen);
        setRewardOption2(DinoFlyingPurple);
        break;
      case 4:
        setRewardOption1(BackpackPurple);
        setRewardOption2(BackpackGreen);
        break;
      case 5:
        setRewardOption1(StegoBlue);
        setRewardOption2(StegoGreen);
        break;
      case 6:
        setRewardOption1(FossilSkull);
        setRewardOption2(FossilArm);
        break;
      case 7:
        setRewardOption1(RaptorLight);
        setRewardOption2(RaptorDark);
        break;
      case 8:
        setRewardOption1(LongNeckGreen);
        setRewardOption2(LongNeckRed);
        break;
      default:
        setdisplayGreenButton(true);
        break;
    }
  }, [keyIcon]);

  const displayReview = () => {
    if (module18.currentday === 4) {
      return (
        <>
          <div className='world2reviewContainer'>
            <img
              className='reviewBtns41'
              src={SingingTimeIcon}
              alt='singing button'
              onClick={() => {
                displaySinging();
              }}
            />
            <img
              className='reviewBtns42'
              src={learnBtn}
              alt='learn button'
              onClick={() => {
                openLearn();
              }}
            />
            <img
              className='reviewBtns43'
              src={practiceBtn}
              alt='practice button'
              onClick={() => {
                openPractice();
              }}
            />
            <img
              className='reviewBtns44'
              src={ftbBtn}
              alt='ftb button'
              onClick={() => {
                openFTB();
              }}
            />
            <img
              className='reviewBtns45'
              src={celebrateBtn}
              alt='celebrate button'
              onClick={() => {
                openCelebrate();
              }}
            />
          </div>
        </>
      );
    } else {
      return (
        <>
          <div className='world2reviewContainer'>
            <img
              className='reviewBtns1'
              src={learnBtn}
              alt='learn button'
              onClick={() => {
                openLearn();
              }}
            />
            <img
              className='reviewBtns2'
              src={practiceBtn}
              alt='practice button'
              onClick={() => {
                openPractice();
              }}
            />
            <img
              className='reviewBtns3'
              src={ftbBtn}
              alt='ftb button'
              onClick={() => {
                openFTB();
              }}
            />
            <img
              className='reviewBtns4'
              src={celebrateBtn}
              alt='celebrate button'
              onClick={() => {
                openCelebrate();
              }}
            />
          </div>
        </>
      );
    }
  };

  const introduction = () => {
    return (
      <div>
        <CloudfrontVideoFormat
          source={introVideo}
          back='/resolveconflict/navigation'
          background={background}
          token={login.cookie}
          ended={() => {
            // here is where you can add dispatch functions
            setDisplayIntroVideo(false);
            setDisplayBody(true);
            if (module18.currentday === 4) {
              dispatch({ type: 'MODULE18_SET_KEY', payload: 1 });
              playButtonAudio();
            }
            if (module18.day_completed === 9) {
              navigate('/resolveconflict/navigation');
            }
          }}
        />
      </div>
    );
  };

  const openLearn = async () => {
    let song = getVideo('appfiles/resolve_conflict/resolve_conflict_demo.m4a', login);
    let video = getVideo('appfiles/resolve_conflict/learn_video.mp4', login);
    switch (module18.currentday) {
      case 1:
        setLearn(
          <Learn
            video='appfiles/resolve_conflict/learn_day_1.mp4'
            songVideo={video}
            closingVideo='appfiles/resolve_conflict/learn_day_1_closing.mp4'
            destiny='/resolveconflict'
            song={song}
            back='/resolveconflict'
            background={background}
            setDisplayLearn={setDisplayLearn}
            step_completed='MODULE18_SET_stepCompleted'
            module={module18}
            module18={true}
            animal={animal}
            learnVideo1={'f08f1e394843ca609f65893072f6/480.m3u8'}
            learnVideo2={'appfiles/resolve_conflict/learn_day_1_step_2.mp4'}
            learnVideo3={'appfiles/resolve_conflict/learn_day_1_step_3.mp4'}
          />
        );
        break;
      case 2:
        setLearn(
          <Learn
            video='appfiles/resolve_conflict/learn_day_2.mp4'
            songVideo={video}
            closingVideo='appfiles/resolve_conflict/learn_day_2_closing.mp4'
            destiny='/resolveconflict'
            song={song}
            back='/resolveconflict'
            background={background}
            setDisplayLearn={setDisplayLearn}
            step_completed='MODULE18_SET_stepCompleted'
            module={module18}
            module18={true}
            animal={animal}
            learnVideo1={'appfiles/resolve_conflict/learn_day_2_step_1.mp4'}
            learnVideo2={'appfiles/resolve_conflict/learn_day_2_step_2.mp4'}
            learnVideo3={'appfiles/resolve_conflict/learn_day_2_step_3.mp4'}
          />
        );
        break;
      case 3:
        setLearn(
          <Learn
            video='appfiles/resolve_conflict/learn_day_3.mp4'
            songVideo={video}
            closingVideo='appfiles/resolve_conflict/learn_day_3_closing.mp4'
            destiny='/resolveconflict'
            song={song}
            back='/resolveconflict'
            background={background}
            setDisplayLearn={setDisplayLearn}
            step_completed='MODULE18_SET_stepCompleted'
            module={module18}
            module18={true}
            animal={animal}
            learnVideo1={'appfiles/resolve_conflict/learn_day_3_step_1.mp4'}
            learnVideo2={'appfiles/resolve_conflict/learn_day_3_step_2.mp4'}
            learnVideo3={'appfiles/resolve_conflict/learn_day_3_step_3.mp4'}
          />
        );
        break;
      default:
        setAnimalVoice(getVideo('appfiles/resolve_conflict/resolve_conflict_learn_intro.mp3', login));
        // setDisplayVoice(true);
        setAnimalState(learnIntro);
        setShowAnimal(true);
        GetUserVideo(`userfiles/${module18.StudentID}/resolve_conflict_play_day_music.m4a`).then((data) => {
          fetch(data).then((response) => {
            GetUserVideo(`influencers/${influencers[module18.currentday - 4]}/ask_affirmation.mp4`).then((influencerVideo) => {
              if (response.status === 200) {
                setLearn(
                  <Learn
                    songVideo={video}
                    destiny='/resolveconflict'
                    song={data}
                    back='/resolveconflict'
                    background={background}
                    setDisplayLearn={setDisplayLearn}
                    step_completed='MODULE18_SET_stepCompleted'
                    module={module18}
                    instrumental={getVideo('appfiles/resolve_conflict/resolve_conflict_final.m4a', login)}
                    influencerVideo={influencerVideo}
                  />
                );
              } else {
                setLearn(
                  <Learn
                    songVideo={video}
                    destiny='/resolveconflict'
                    song={song}
                    back='/resolveconflict'
                    background={background}
                    setDisplayLearn={setDisplayLearn}
                    step_completed='MODULE18_SET_stepCompleted'
                    module={module18}
                    influencerVideo={influencerVideo}
                  />
                );
              }
            });
          });
        });
        break;
    }
    setDisplayLearn(true);
  };

  const openPractice = async () => {
    switch (module18.currentday) {
      case 1:
        setPractice(
          <Practice
            video1={'appfiles/resolve_conflict/practice_day_1.mp4'}
            video2={'appfiles/resolve_conflict/practice_day_1_review.mp4'}
            setDisplayPractice={setDisplayPractice}
            background={background}
            stepComplete={'MODULE18_SET_stepCompleted'}
            module={module18}
            animal={animal}
          />
        );
        break;
      case 2:
        setPractice(
          <Practice
            video1={'appfiles/resolve_conflict/practice_day_2.mp4'}
            video2={'appfiles/resolve_conflict/practice_day_1_review.mp4'}
            setDisplayPractice={setDisplayPractice}
            background={background}
            stepComplete={'MODULE18_SET_stepCompleted'}
            module={module18}
            animal={animal}
          />
        );
        break;
      case 3:
        setPractice(
          <Practice
            video1={'appfiles/resolve_conflict/practice_day_3.mp4'}
            video2={'appfiles/resolve_conflict/practice_day_1_review.mp4'}
            setDisplayPractice={setDisplayPractice}
            background={background}
            stepComplete={'MODULE18_SET_stepCompleted'}
            module={module18}
            animal={animal}
          />
        );
        break;
      default:
        const optionTakeBreaths = {
          img: generateImageUrl('images/Module18Images/practice/Take deep breaths.png'),
          title: 'Take deep breaths',
          audioPrompt: 'appfiles/resolve_conflict/option_take_breaths.mp3',
        };
        const optionYell = {
            img: generateImageUrl('images/Module18Images/practice/yell.png'),
            title: 'Yell',
            audioPrompt: 'appfiles/resolve_conflict/option_yell.mp3',
        };
        const optionHit = {
            img: generateImageUrl('images/Module18Images/practice/hit.png'),
            title: 'Hit',
            audioPrompt: 'appfiles/resolve_conflict/option_hit.mp3',
        };
        const optionCalmVoice = {
            img: generateImageUrl('images/Module18Images/practice/calm voice.png'),
            title: 'Calm Voice',
            audioPrompt: 'appfiles/resolve_conflict/option_calm_voice.mp3',
        };
        const optionWhipser = {
            img: generateImageUrl('images/Module18Images/practice/whisper.png'),
            title: 'Whipser',
            audioPrompt: 'appfiles/manners/option_whisper.mp3',
        };
        const optionLoudVoice = {
            img: generateImageUrl('images/Module18Images/practice/loud voice.png'),
            title: 'Loud voice',
            audioPrompt: 'appfiles/resolve_conflict/option_loud_voice.mp3',
        };
        const optionIgnore = {
            img: generateImageUrl('images/Module18Images/practice/ignore them.png'),
            title: 'Ignore them',
            audioPrompt: 'appfiles/resolve_conflict/option_ignore.mp3',
        };
        const optionShareSeat = {
            img: generateImageUrl('images/Module18Images/practice/share the same seat.png'),
            title: 'Share the same seat',
            audioPrompt: 'appfiles/resolve_conflict/option_share_seat.mp3',
        };
        const optionTellFeel = {
            img: generateImageUrl('images/Module18Images/practice/tell her how you feel.png'),
            title: 'Tell her how you feel',
            audioPrompt: 'appfiles/resolve_conflict/option_tell_feel.mp3',
        };
        const optionPlayToy = {
            img: generateImageUrl('images/Module18Images/practice/playing with the toy together.png'),
            title: 'Playing with the toy together',
            audioPrompt: 'appfiles/resolve_conflict/option_play_toy.mp3',
        };
        const optionCalm = {
            img: generateImageUrl('images/Module18Images/practice/be calm and have calm hands.png'),
            title: 'Be calm and have calm hands',
            audioPrompt: 'appfiles/resolve_conflict/option_calm.mp3',
        };
        const optionBeCalm = {
            img: generateImageUrl('images/Module18Images/practice/be calm.png'),
            title: 'Be calm',
            audioPrompt: 'appfiles/resolve_conflict/option_be_calm.mp3',
        };
        const optionListenSaying = {
            img: generateImageUrl('images/Module18Images/practice/listen to what he is saying.png'),
            title: 'Listen to what he is saying',
            audioPrompt: 'appfiles/resolve_conflict/option_listen_saying.mp3',
        };
        const optionMeanVoice = {
            img: generateImageUrl('images/Module18Images/practice/talk back to your friend.png'),
            title: 'Talk back in a mean voice',
            audioPrompt: 'appfiles/resolve_conflict/option_talk_mean.mp3',
        };
        const optionNotListen = {
            img: generateImageUrl('images/Module18Images/practice/not listen.png'),
            title: 'Not listen',
            audioPrompt: 'appfiles/resolve_conflict/option_not_listen.mp3',
        };
        const optionGiveBack = {
            img: generateImageUrl('images/Module18Images/practice/say I am sorry and give it back.png'),
            title: 'Say I am sorry and give it back',
            audioPrompt: 'appfiles/resolve_conflict/option_give_back.mp3',
        };
        const optionThrowIt = {
            img: generateImageUrl('images/Module18Images/practice/throw it.png'),
            title: 'Throw it',
            audioPrompt: 'appfiles/resolve_conflict/option_throw_it.mp3',
        };
        const optionNoGiveBack = {
            img: generateImageUrl('images/Module18Images/practice/not give it back.png'),
            title: 'Not give it back',
            audioPrompt: 'appfiles/resolve_conflict/option_no_give_back.mp3',
        };
        const optionTalkBack = {
            img: generateImageUrl('images/Module18Images/practice/talk back to your friend.png'),
            title: 'Talk back to your friend',
            audioPrompt: 'appfiles/resolve_conflict/option_talk_back.mp3',
        };
        const optionListenFriend = {
            img: generateImageUrl('images/Module18Images/practice/listen to your friend.png'),
            title: 'Listen to your friend',
            audioPrompt: 'appfiles/resolve_conflict/option_listen_friend.mp3',
        };
        const optionMakeRoom = {
            img: generateImageUrl('images/Module18Images/practice/say sorry and make room for her.png'),
            title: 'Say sorry and make room for her',
            audioPrompt: 'appfiles/resolve_conflict/option_make_room.mp3',
        };
        const optionPush = {
            img: generateImageUrl('images/Module18Images/practice/push.png'),
            title: 'Push',
            audioPrompt: 'appfiles/resolve_conflict/option_push.mp3',
        };
        const optionBeCareful = {
            img: generateImageUrl('images/Module18Images/practice/please be more careful.png'),
            title: 'Please be more careful',
            audioPrompt: 'appfiles/resolve_conflict/option_be_careful.mp3',
        };
        const optionGoHome = {
            img: generateImageUrl('images/Module18Images/practice/go home.png'),
            title: 'Go home',
            audioPrompt: 'appfiles/resolve_conflict/option_go_home.mp3',
        };
        const optionNeverBump = {
            img: generateImageUrl('images/Module18Images/practice/never bump me again.png'),
            title: 'Never bump me again',
            audioPrompt: 'appfiles/resolve_conflict/option_never_bump.mp3',
        };
        const optionDinoPics = {
            img: generateImageUrl('images/Module18Images/practice/take pictuers of the dinosaurs together.png'),
            title: 'Take pictures of the dinosaur together',
            audioPrompt: 'appfiles/resolve_conflict/option_dino_pics.mp3',
        };
        const optionHitting = {
            img: generateImageUrl('images/Module18Images/practice/hitting.png'),
            title: 'Hitting',
            audioPrompt: 'appfiles/resolve_conflict/option_hitting.mp3',
        };
        const optionYelling = {
            img: generateImageUrl('images/Module18Images/practice/yelling.png'),
            title: 'Yelling',
            audioPrompt: 'appfiles/resolve_conflict/option_yelling.mp3',
        };
        /// ////
        const scenarioBusBeCalm = {
          prompt:
            'If a classmate sits where you wanted to sit on the bus, you should',
          audioPrompt: 'appfiles/resolve_conflict/scenario_bus_be_calm.mp3',
          correctMatch: optionTakeBreaths,
          incorrectMatches: [optionYell, optionHit],
        };

        const scenarioBusTalk = {
          prompt: 'After you take deep breaths, you should talk to them in a',
          audioPrompt: 'appfiles/resolve_conflict/scenario_bus_talk.mp3',
          correctMatch: optionCalmVoice,
          incorrectMatches: [optionLoudVoice, optionWhipser],
        };

        const scenarioBusBetter = {
          prompt:
            'After you talk to them in a calm voice, you can make it better when you',
          audioPrompt: 'appfiles/resolve_conflict/scenario_bus_better.mp3',
          correctMatch: optionShareSeat,
          incorrectMatches: [optionYell, optionHit],
        };

        const scenarioGiftBeCalm = {
          prompt:
            'If a classmate says she does not like the toy you picked out at the gift shop, you should',
          audioPrompt: 'appfiles/resolve_conflict/scenario_gift_be_calm.mp3',
          correctMatch: optionBeCalm,
          incorrectMatches: [optionYell, optionHit],
        };

        const scenarioGiftTalk = {
          prompt: 'After you are calm, you should',
          audioPrompt: 'appfiles/resolve_conflict/scenario_gift_talk.mp3',
          correctMatch: optionTellFeel,
          incorrectMatches: [optionHit, optionYell],
        };

        const scenarioGiftBetter = {
          prompt:
            'After you talk about it and your classmate says she is sorry, you can make it better by',
          audioPrompt: 'appfiles/resolve_conflict/scenario_gift_better.mp3',
          correctMatch: optionPlayToy,
          incorrectMatches: [optionYelling, optionHitting],
        };

        const scenarioDigBeCalm = {
          prompt:
            'If your friend gets mad at your because you took his shovel, you should',
          audioPrompt: 'appfiles/resolve_conflict/scenario_dig_be_calm.mp3',
          correctMatch: optionBeCalm,
          incorrectMatches: [optionYell, optionHit],
        };

        const scenarioDigTalk = {
          prompt:
            'When your friend tells you he was sad because you took his shovel, you should',
          audioPrompt: 'appfiles/resolve_conflict/scenario_dig_talk.mp3',
          correctMatch: optionListenSaying,
          incorrectMatches: [optionMeanVoice, optionNotListen],
        };

        const scenarioDigBetter = {
          prompt: 'After you listen to your friend, you should',
          audioPrompt: 'appfiles/resolve_conflict/scenario_dig_better.mp3',
          correctMatch: optionGiveBack,
          incorrectMatches: [optionThrowIt, optionNoGiveBack],
        };

        const scenarioDinoBeCalm = {
          prompt:
            'If your friend gets mad at you because you stood in front of her so she could not see the dinosaur, you should',
          audioPrompt: 'appfiles/resolve_conflict/scenario_dino_be_calm.mp3',
          correctMatch: optionBeCalm,
          incorrectMatches: [optionYell, optionHit],
        };

        const scenarioDinoTalk = {
          prompt:
            'After your friend calms down and tells you why she was mad, you should',
          audioPrompt: 'appfiles/resolve_conflict/scenario_dino_talk.mp3',
          correctMatch: optionListenFriend,
          incorrectMatches: [optionTalkBack, optionNotListen],
        };

        const scenarioDinoBetter = {
          prompt: 'After you listen to your friend, you should',
          audioPrompt: 'appfiles/resolve_conflict/scenario_dino_better.mp3',
          correctMatch: optionMakeRoom,
          incorrectMatches: [optionPush, optionYell],
        };

        const scenarioHerbBeCalm = {
          prompt:
            'If you are taking a picture of the dinosaurs and your classmate bumps into you, you should',
          audioPrompt: 'appfiles/resolve_conflict/scenario_herb_be_calm.mp3',
          correctMatch: optionBeCalm,
          incorrectMatches: [optionYell, optionHit],
        };

        const scenarioHerbTalk = {
          prompt:
            'After you are calm, you can talk to your classmate in a calm voice and ask him to',
          audioPrompt: 'appfiles/resolve_conflict/scenario_herb_talk.mp3',
          correctMatch: optionBeCareful,
          incorrectMatches: [optionGoHome, optionNeverBump],
        };

        const scenarioHerbBetter = {
          prompt:
            'After you tell him to please be more careful and he apologizes, you can make it better when you',
          audioPrompt: 'appfiles/resolve_conflict/scenario_herb_better.mp3',
          correctMatch: optionDinoPics,
          incorrectMatches: [optionIgnore, optionYell],
        };

        const names = [
          [
            'resolve_conflict_practice_1_5.mp4',
            'resolve_conflict_practice_2_5.mp4',
            'resolve_conflict_practice_3_5.mp4',
          ],
          [
            'resolve_conflict_practice_1_6.mp4',
            'resolve_conflict_practice_2_6.mp4',
            'resolve_conflict_practice_3_6.mp4',
          ],
          [
            'resolve_conflict_practice_1_7.mp4',
            'resolve_conflict_practice_2_7.mp4',
            'resolve_conflict_practice_3_7.mp4',
          ],
          [
            'resolve_conflict_practice_1_8.mp4',
            'resolve_conflict_practice_2_8.mp4',
            'resolve_conflict_practice_3_8.mp4',
          ],
          [
           'resolve_conflict_practice_1_9.mp4',
           'resolve_conflict_practice_2_9.mp4',
           'resolve_conflict_practice_3_9.mp4',
          ],
        ];
        const options = [
          [scenarioBusBeCalm, scenarioBusTalk, scenarioBusBetter],
          [scenarioGiftBeCalm, scenarioGiftTalk, scenarioGiftBetter],
          [scenarioDigBeCalm, scenarioDigTalk, scenarioDigBetter],
          [scenarioDinoBeCalm, scenarioDinoTalk, scenarioDinoBetter],
          [scenarioHerbBeCalm, scenarioHerbTalk, scenarioHerbBetter],
        ];
        const titles = [
          'Step 1: Be Calm',
          'Step 2: Talk about it',
          'Step 3: Make it better',
        ];
        const instructions = [
          [
            'appfiles/resolve_conflict/practice_bus_1.mp4',
            'appfiles/resolve_conflict/practice_bus_2.mp4',
            'appfiles/resolve_conflict/practice_bus_3.mp4',
          ],
          [
            'appfiles/resolve_conflict/practice_gift_1.mp4',
            'appfiles/resolve_conflict/practice_gift_2.mp4',
            'appfiles/resolve_conflict/practice_gift_3.mp4',
            'appfiles/resolve_conflict/practice_gift_4.mp4',
          ], 
          [
            'appfiles/resolve_conflict/practice_dig_1.mp4',
            'appfiles/resolve_conflict/practice_dig_2.mp4',
            'appfiles/resolve_conflict/practice_dig_3.mp4',
          ],
          [
            'appfiles/resolve_conflict/practice_dino_1.mp4',
            'appfiles/resolve_conflict/practice_dino_2.mp4',
            'appfiles/resolve_conflict/practice_dino_3.mp4',
            'appfiles/resolve_conflict/practice_dino_4.mp4',
          ],
          [
            'appfiles/resolve_conflict/practice_herb_1.mp4',
            'appfiles/resolve_conflict/practice_herb_2.mp4',
            'appfiles/resolve_conflict/practice_herb_3.mp4',
            'appfiles/resolve_conflict/practice_herb_4.mp4',
          ],
        ];
        const texts = [
          [
            `Press record and say, "I am sad, because I want to sit where you are sitting."`,
            `Press record and say, "I am sorry, I should not tell you to move."`,
            `Press record and say, "Thanks, and let's sit by each other on the way home too!"`,
          ],
          [
            `Press record and say, "I feel sad you do not like my toy. Can you tell me why?"`,
            `Press record and say, "Thanks! It is okay to like different things."`,
            `Press record and say, "Do you want to play with my toy?"`,
          ],
          [
            `Press record and say, "Hi, what is wrong?"`,
            `Press record and say, "I am sorry I took your shovel. I did not know you were using it."`,
            `Press record and say, "Yes, and next time I will ask before taking a shovel."`,
          ], 
          [
            `Press record and say, "I am sorry, I did not see you standing there."`,
            `Press record and say, "I can move over so you can see the dinosaur too!"`,
            `Press record and say, "I will make sure to watch where I am standing next time."`,
          ],
          [
            `Press record and say, "Please be more careful, I am trying to take a picture."`,
            `Press record and say, "It is okay."`,
            `Press record and say, "Thanks, do you want to take pictures with me?"`,
          ],
          
        ];
        const voices = [
          [
            'appfiles/resolve_conflict/resolve_conflict_practice_bus_prompt_1.mp3',
            'appfiles/resolve_conflict/resolve_conflict_practice_bus_prompt_2.mp3',
            'appfiles/resolve_conflict/resolve_conflict_practice_bus_prompt_3.mp3',
          ],
          [
            'appfiles/resolve_conflict/resolve_conflict_practice_gift_prompt_1.mp3',
            'appfiles/resolve_conflict/resolve_conflict_practice_gift_prompt_2.mp3',
            'appfiles/resolve_conflict/resolve_conflict_practice_gift_prompt_3.mp3',
          ],
          [
            'appfiles/resolve_conflict/resolve_conflict_practice_dig_prompt_1.mp3',
            'appfiles/resolve_conflict/resolve_conflict_practice_dig_prompt_2.mp3',
            'appfiles/resolve_conflict/resolve_conflict_practice_dig_prompt_3.mp3',
          ],
          [
            'appfiles/resolve_conflict/resolve_conflict_practice_dino_prompt_1.mp3',
            'appfiles/resolve_conflict/resolve_conflict_practice_dino_prompt_2.mp3',
            'appfiles/resolve_conflict/resolve_conflict_practice_dino_prompt_3.mp3',
          ],
          [
            'appfiles/resolve_conflict/resolve_conflict_practice_herb_prompt_1.mp3',
            'appfiles/resolve_conflict/resolve_conflict_practice_herb_prompt_2.mp3',
            'appfiles/resolve_conflict/resolve_conflict_practice_herb_prompt_3.mp3',
          ],
        ];
        const exampleVideos = [
          '404cb8c87ea68b34d68800759f38/480.m3u8',
          'fdddc64c4ad070485f1c4acc2d2b/480.m3u8',
          '1ff916c5d26e53fbe959c4cca11e/480.m3u8',
          '18146ebf75b03a8d7c401bc13231/480.m3u8',
          '04f9df0feca686e42f2da64e25ba/480.m3u8',
        ];
        setAnimalVoice(getVideo('appfiles/resolve_conflict/resolve_conflict_practice_intro.mp3', login));
        // setDisplayVoice(true);
        setAnimalState(practiceIntro);
        setShowAnimal(true);
        setPractice(
          <PracticeRecording
            score={'practice_resolve_conflict'}
            score_target={3}
            options={options[module18.currentday - 4]}
            titles={titles}
            setDisplayPractice={setDisplayPractice}
            background={background}
            stepComplete={'MODULE18_SET_stepCompleted'}
            module={module18}
            animal={animal}
            module18={true}
            instructions={instructions[module18.currentday - 4]}
            names={names[module18.currentday - 4]}
            texts={texts[module18.currentday - 4]}
            voices={voices[module18.currentday - 4]}
            influencerid={influencers[module18.currentday - 4]}
            introduction={practiceIntro}
            introductionMP3={'appfiles/resolve_conflict/practice_conversation.mp3'}
            practiceConversation={watchConversation}
            practiceMessage={specialMessage}
            awesomeJob={amazingJob}
            practiceConversationAudio={'media/Module16/watch_conversation.mp3'}
            practiceMessageAudio={'appfiles/ask/ask_practice_special_message.mp3'}
            awesomeJobAudio={'appfiles/ask/ask_awesome_job.mp3'}
            bigAnimal={true}
            lizard={true}
            exampleVideo={exampleVideos[module18.currentday - 4]}
          />
        );
        break;
    }
    setDisplayPractice(true);
  };

  const openFTB = async () => {
    switch (module18.currentday) {
      case 1:
        break;
      case 2:
        break;
      case 3:
        break;

      default:
        setAnimalVoice(getVideo('appfiles/ask/ask_ftb_intro.mp3', login));
        // setDisplayVoice(true);
        setAnimalState(ftbIntro);
        setShowAnimal(true);
        break;
    }

    setDisplayFTB(true);
  };

  const openCelebrate = async () => {
    const celebrateVideo1 = 'appfiles/resolve_conflict/celebrate_day_1.mp4';
    const celebrateVideo2 = 'appfiles/resolve_conflict/celebrate_day_1.mp4';
    const celebrateVideo3 = 'appfiles/resolve_conflict/celebrate_day_1.mp4';

    switch (module18.currentday) {
      case 1:
        setCelebrate(
          <Celebrate
            module={module18}
            celebrateVideo={celebrateVideo1}
            background={background}
            setDisplayCelebrate={setDisplayCelebrate}
            moduleNum={'MODULE18'}
          />
        );
        break;
      case 2:
        setCelebrate(
          <Celebrate
            module={module18}
            celebrateVideo={celebrateVideo2}
            background={background}
            setDisplayCelebrate={setDisplayCelebrate}
            moduleNum={'MODULE18'}
          />
        );
        break;
      case 3:
        setCelebrate(
          <Celebrate
            module={module18}
            celebrateVideo={celebrateVideo3}
            background={background}
            setDisplayCelebrate={setDisplayCelebrate}
            moduleNum={'MODULE18'}
          />
        );
        break;
      default:
        let audios = ['appfiles/resolve_conflict/resolve_conflict_celebrate_calm.mp3',
        'appfiles/resolve_conflict/resolve_conflict_celebrate_feelings.mp3',
        'appfiles/resolve_conflict/resolve_conflict_celebrate_listener.mp3',
        'appfiles/resolve_conflict/resolve_conflict_celebrate_solve_problems.mp3',
        'appfiles/resolve_conflict/resolve_conflict_celebrate_better.mp3']
        let text = [`Record yourself in an excited voice and say, "I am a very important person because I know when to be calm!"`,
        `Record yourself in an excited voice and say, "I am a very important person because I can talk about my feelings!"`,
        `Record yourself in an excited voice and say, "I am a very important person because I am a good listener!"`,
        `Record yourself in an excited voice and say, "I am a very important person because I solve problems with friends!"`,
        `Record yourself in an excited voice and say, "I am a very important person because I can make things better!"`]
        setAnimalVoice(getVideo('appfiles/ask/ask_celebrate_intro.mp3', login));
        // setDisplayVoice(true);
        setAnimalState(celebrateIntro);
        setShowAnimal(true);
        let voice1 = getVideo(audios[module18.currentday-4], login)
        let voice2 = getVideo('appfiles/ask/ask_celebrate_say_yes.mp3', login)
        let voice3 = getVideo('appfiles/ask/ask_awesome_job.mp3', login)
        let animalGIF = getVideo('appfiles/change_feelings/lizard joyful jingle.gif', login)
        let animalVoice = getVideo('appfiles/change_feelings/change_feelings_joyful_jingle_intro.mp3', login)
        await GetUserVideo(`influencers/${influencers[module18.currentday - 4]}/ask_affirmation.mp4`).then((influencerVideo) => { 
          setCelebrate(
            <Celebrate
              world3={true}
              module={module18}
              background={background}
              voice1={voice1}
              voice2={voice2}
              voice3={voice3}
              animalGIF={animalGIF}
              animalVoice={animalVoice}
              text={text[module18.currentday-4]}
              name={`resolve_conflict_celebration_surprise_${
                module18.currentday + 1
              }.mp4`}
              influencerVideo={influencerVideo}
              animation={amazingJob}
              animal={animal}
              setDisplayCelebrate={setDisplayCelebrate}
              moduleNum={'MODULE18'}
              bigAnimal={true}
              lizard={true}
            />
          ) 
        })
        break;
    }
    setDisplayCelebrate(true);
  };

  const displaySinging = async () => {
    const introVideo = getVideo('appfiles/resolve_conflict/singing_time.mp4', login);
    const noteVideo = getVideo('appfiles/resolve_conflict/resolve_conflict_student_notes.mp4', login);
    const singingMusic = getVideo('appfiles/resolve_conflict/resolve_conflict_demo.m4a', login);
    const instrumental = getVideo('appfiles/resolve_conflict/resolve_conflict_instrumental.m4a', login);
    setSingTime(
      <SingingTime
        introVideo={introVideo}
        demoMusic={singingMusic}
        singingVideo={noteVideo}
        background={background}
        singingMusic={singingMusic}
        setDisplaySingingTime={setDisplaySingingTime}
        module={module18}
        moduleNum='MODULE18'
        name='resolve_conflict'
        instrumental={instrumental}
        instrumentalURL={'appfiles/resolve_conflict/resolve_conflict_final.m4a'}
      />
    );
    setDisplaySingingTime(true);
  };

  const getSurprise = async () => {
    const usePhoto = [
      {
        video: `influencers/${login.influencerid}/ask_affirmation.mp4`,
      },
      {
        video: `userfiles/${module18.StudentID}/resolve_conflict_celebration_surprise_5.mp4`,
      },
      {
        video: 'appfiles/resolve_conflict/practice_bus_1.mp4',
      },
      {
        video: `userfiles/${module18.StudentID}/resolve_conflict_practice_1_5.mp4`,
      },
      {
        video: 'appfiles/resolve_conflict/practice_bus_2.mp4',
      },
      {
        video: `userfiles/${module18.StudentID}/resolve_conflict_practice_2_5.mp4`,
      },
      {
        video: 'appfiles/resolve_conflict/practice_bus_3.mp4',
      },
      {
        video: `userfiles/${module18.StudentID}/resolve_conflict_practice_3_5.mp4`,
      },
      {
        video: `influencers/${login.influencerid2}/conversation_affirmation.mp4`,
      },
      {
        video: `userfiles/${module18.StudentID}/resolve_conflict_celebration_surprise_6.mp4`,
      },
      {
        video: `influencers/${login.influencerid1}/answer_affirmation.mp4`,
      },
      {
        video: `userfiles/${module18.StudentID}/resolve_conflict_celebration_surprise_7.mp4`,
      },
      {
        video: `influencers/${login.influencerid3}/ask_affirmation.mp4`,
      },
      {
        video: `userfiles/${module18.StudentID}/resolve_conflict_celebration_surprise_8.mp4`,
      },
      {
        video: `influencers/${login.influencerid4}/ask_affirmation.mp4`,
      },
    ];

    for (let i = 0; i < usePhoto.length; ++i){
      await GetUserVideo(usePhoto[i].video, login).then((data) => {
        usePhoto[i].video = data;
      });
    }
  
    return usePhoto;
  };

  const playSurpriseVideo = async () => {
    await getSurprise().then((photo) => {
      setSurpriseVideo(
        <Surprise
          background={background}
          music={getVideo('appfiles/resolve_conflict/resolve_conflict_instrumental.m4a', login)}
          animal={animal}
          back={'/'}
          slides={photo}
          setDisplaySurprise={setDisplaySurprise}
        />
      );
    });

    setDisplaySurprise(true);
    setKeyIcon(true);
    setPresentIcon(false);
  };

  const playButtonAudio = () => {
    sleep(700).then(() => {
      setButtonSound(true);
    });
  };

  const rewardAnimation = () => {
    setRewardAnimationState('fade-out-fly');
    sleep(1000).then(() => {
      flyAnimation();
    });
  };

  const flyAnimation = () => {
    setShowFly(true);
    setAnimalState(lizardTongue);
    setAnimalVoice(lizardTongueAudio);
    setShowAnimal(true);
    setKeyIcon(false);
  };

  const closeDay9Video = () => {
    setDisplayIntroVideo(true);
    setDisplayBody(false);
    setIntroVideo(getVideo(AfterCelebrateVideo9, login));
    setShowAnimal(false);
  };

  const onStop = (reward, data) => {
    const position = { x: data.x / clientWidth, y: data.y / clientHeight };

    if (reward === 1 || reward === 2) {
      dispatch({
        type: `MODULE18_SET_PRIZE${reward}_POSITION`,
        payload: position,
      });
    } else {
      dispatch({
        type: `MODULE18_SET_REWARD${reward}_POSITION`,
        payload: position,
      });
    }
  };

  const isIOS = () => {
    return [
      'iPad Simulator',
      'iPhone Simulator',
      'iPod Simulator',
      'iPad',
      'iPhone',
      'iPod'
    ].includes(navigator.platform)
    // iPad on iOS 13 detection
    || (navigator.userAgent.includes("Mac") && "ontouchend" in document)
  }

  useEffect(() => {
    let timer;
    if(displayVoice && isIOS()) {
      timer = setTimeout(() => {
        setAudioReady(false);
        setDisplayVoice(false);
        setShowAnimal(false);
      }, 5000);
    }
    return () => {
      if(timer) clearTimeout(timer);
    }
  }, [displayVoice]);

  useEffect(() => {
    let timer;
    if(playLizardClose && isIOS()) {
      timer = setTimeout(() => {
        setPlayLizardClose(false);
        if(module18.currentday === 8) {
          closeDay9Video();
        } else {
          navigate('/resolveconflict/navigation');
        }
      }, 5000);
    }
    return () => {
      if(timer) clearTimeout(timer);
    }
  }, [playLizardClose]);

  useEffect(() => {
    let timer;
    if(coinAudio && isIOS()) {
      timer = setTimeout(() => {
        dispatch({ type: 'MODULE18_SET_COIN', payload: module18.coins + 1 });
        setCoinAudio(false);
        setCoinAnimationState('bounceIcons');
        setCoinIcon(false);
        playButtonAudio();
      }, 5000);
    }
    return () => {
      if(timer) clearTimeout(timer);
    }
  }, [coinAudio]);

  return (
    <>
      {coinAudio && (
        <audio
          autoPlay
          onEnded={() => {
            dispatch({
              type: 'MODULE18_SET_COIN',
              payload: module18.coins + 1,
            });
            setCoinAudio(false);
            setCoinAnimationState('bounceIcons');
            setCoinIcon(false);
            playButtonAudio();
          }}
        >
          <source
            src={
              generateImageUrl('media/Module5Videos/earn_token.mp3')
            }
            type='audio/mp3'
          />
        </audio>
      )}
      {playLizardClose && (
        <audio
          autoPlay
          onPlay={() => {
            setAudioReady(true);
          }}
          onEnded={() => {
            setPlayLizardClose(false);
            module18.currentday === 8
              ? closeDay9Video()
              : navigate('/resolveconflict/navigation');
          }}
        >
          <source src={animalCloseAudio} type='audio/mp3' />
        </audio>
      )}

      {checkSound && (
        <audio
          autoPlay
          onEnded={() => {
            setCheckSound(false);
          }}
        >
          <source
            src={
              generateImageUrl('media/Module1Videos/button_accept_item.mp3')
            }
            type='audio/mp3'
          />
        </audio>
      )}
      {rewardsFound && (
        <audio autoPlay>
          <source
            src={
              generateImageUrl('media/Module2Videos/daily_rewards_present.mp3')
            }
          ></source>
        </audio>
      )}
      {touchButton && (
        <audio
          autoPlay
          onEnded={() => {
            setTouchButton(false);
          }}
        >
          <source
            src={
              generateImageUrl('media/Module1Videos/touch_button.mp3')
            }
            type='audio/mp3'
          />
        </audio>
      )}
      {buttonSound && (
        <audio
          autoPlay
          onEnded={() => {
            setButtonSound(false);
          }}
        >
          <source
            src={
              generateImageUrl('media/Module1Videos/button_bouncing.mp3')
            }
            type='audio/mp3'
          />
        </audio>
      )}
      {displayVoice && (
        <audio
          autoPlay
          onPlay={() => {
            setAudioReady(true);
          }}
          onEnded={() => {
            setAudioReady(false);
            setDisplayVoice(false);
            setShowAnimal(false);
            if (showFly) {
              setShowFly(false);
              setDisplayReward(true);
              setRewardsFound(true);
            }
          }}
        >
          <source src={animalVoice}></source>
        </audio>
      )}
      {displayIntroVideo && introduction()}
      {!showAnimal && displayLearn && learn}
      {!showAnimal && displayPractice && practice}
      {!showAnimal && displayFTB && (
        <FollowTheBeatModule8
          unit4={true}
          setDisplayFTB={setDisplayFTB}
          awesomeJob={awesomeJob}
          awesomeJobGIF={amazingJob}
          instruction={ftbInstruction}
          instructionGIF={ftbInstructionGIF}
          song={ftbMusic}
          count={ftbCount}
          tutorial1={ftbTutorial1}
          tutorial1_2={ftbTutorial1_2}
          tutorial2={ftbTutorial2}
          walkthrough={ftbWT}
          stepComplete={'MODULE18_SET_stepCompleted'} 
          module={module18}
          score={'ftb_resolve_conflict'}
        />
      )}
      {displaySingingTime && singTime}
      {!showAnimal && displayCelebrate && celebrate}
      {displaySurprise && surpriseVideo}
      {((displaybody &&
        !displayLearn &&
        !displayPractice &&
        !displaySingingTime &&
        !displayCelebrate &&
        !displaySurprise &&
        !displayFTB &&
        !displayDay4Practice) ||
        showAnimal) && (
        <div
          className='askWorldBody'
          style={{ backgroundImage: `url(${background})` }}
        >
          <div className='navigation'>
            <img
              className='logoutBtn'
              src={logoutBtn}
              alt='Logout Button'
              onClick={togglePopup}
            />
            <img
              className='JourneyBlueImage'
              src={journeyImage}
              alt='Navigation blue world Image'
              onClick={() => {
                navigate('/resolveconflict/navigation');
              }}
            />
          </div>
          {isOpen && (
            <PopUp
              content={
                <>
                  <b id='title'>
                    Are you sure you want to leave?
                    <br />
                  </b>
                  <button
                    id='logoutButton1'
                    className='logoutButton'
                    onClick={() => {
                      navigate('/');
                      userHasAuthenticated(false);
                      localStorage.setItem('token', 'false');
                    }}
                  >
                    YES
                  </button>
                  <button
                    id='logoutButton2'
                    className='logoutButton'
                    onClick={togglePopup}
                  >
                    NO
                  </button>
                </>
              }
              handleClose={togglePopup}
            />
          )}

          {prize && (
            <audio autoPlay>
              <source src={presentSound}></source>
            </audio>
          )}

          {prize && (
            <img
              className='prize'
              src={
                generateImageUrl('images/Images/prize.png')
              }
              alt='Logout Button'
              onClick={() => {
                setPrize(false);
                rewardAnimation();
                sleep(1000).then(() => {
                  sleep(5000).then(() => {
                    setDisplayPrize(true);
                  });
                });
              }}
            />
          )}
          {prize && (
            <button
              className='prize-button'
              onClick={() => {
                setPrize(false);
                setDisplayPrize(true);
              }}
            >
              {' '}
              <h5>Click Here</h5>
            </button>
          )}
          {disPlayPrize && openPrize()}

          <img className='lizard' src={animal} alt='lizard Icon' />
          {showAnimal && !audioReady && (
            <img alt='' id='loading' src={loading} />
          )}
          {showAnimal && (
            <img
            className={
              animalState === lizardTongue ? 'lizardTongue' : 'animatedLizard'
            }
              style={audioReady ? {} : { display: 'none' }}
              src={animalState}
              onLoad={() => setDisplayVoice(true)}
              onError={() => setShowAnimal(false)}
            />
          )}

          <div className='scoreBar'>
            <img
              className='scoreKey'
              src={coinBar}
              alt='crab Icon'

            />
            {module18.coins < 10 && (
              <h5 className='scoretext1'>{module18.coins}</h5>
            )}
            {module18.coins >= 10 && module18.coins < 100 && (
              <h5 className='scoretext10'>{module18.coins}</h5>
            )}
            {module18.coins >= 100 && (
              <h5 className='scoretext100'>{module18.coins}</h5>
            )}
            <p className='scoretext'>100</p>
          </div>

          {module18.currentday === 4 || module18.currentday === 8 ? (
            <div className='progressBar3'>
              <img
                className='progressKey3'
                src={keys5[module18.keys]}
                alt='crab Icon'
                
              />
              <h3 className='progresstext3'>{module18.keys}/5</h3>
            </div>
          ) : (
            <div className='progressBar3'>
              <img
                className='progressKey3'
                src={keys4[module18.keys]}
                alt='crab Icon'
                
              />
              <h3 className='progresstext3'>{module18.keys}/4</h3>
            </div>
          )}

          {!showAnimal &&
            !module18.reviewIcon &&
            !coinIcon &&
            !disPlayPrize && 
            !dropZone && (
              <div className='actionBtnDiv'>
                {module18.currentday === 4 &&
                  module18.stepCompleted === 'notstarted' && (
                    <img
                      className='actionBtn2'
                      id='bounceIcons'
                      src={SingingTimeIcon}
                      alt='learn button'
                      onClick={() => {
                        setTouchButton(true);
                        sleep(500).then(() => {
                          displaySinging();
                          setCheckStep('singingtime');
                        });
                      }}
                    />
                  )}
                {module18.currentday !== 4 &&
                  module18.stepCompleted === 'notstarted' && (
                    <img
                      className='actionBtn2'
                      id='bounceIcons'
                      src={learnBtn}
                      alt='learn button'
                      onClick={() => {
                        setTouchButton(true);
                        sleep(500).then(() => {
                          openLearn();
                          setCheckStep('learn');
                        });
                      }}
                    />
                  )}

                {module18.stepCompleted === 'learn' && (
                  <img
                    className='actionBtn2'
                    id='bounceIcons'
                    src={practiceBtn}
                    alt='practice button'
                    onClick={() => {
                      setTouchButton(true);
                      sleep(500).then(() => {
                        openPractice();
                        setCheckStep('practice');
                      });
                    }}
                  />
                )}
                {module18.stepCompleted === 'practice' && (
                  <img
                    className='actionBtn2'
                    id='bounceIcons'
                    src={ftbBtn}
                    alt='celebrate button'
                    onClick={() => {
                      setTouchButton(true);
                      sleep(500).then(() => {
                        openFTB();
                        setCheckStep('followthebeat');
                      });
                    }}
                  />
                )}
                {module18.stepCompleted === 'followthebeat' && (
                  <img
                    className='actionBtn2'
                    id='bounceIcons'
                    src={celebrateBtn}
                    alt='celebrate button'
                    onClick={() => {
                      setTouchButton(true);
                      sleep(500).then(() => {
                        openCelebrate();
                        setCheckStep('celebrate');
                      });
                    }}
                  />
                )}
                {module18.stepCompleted === 'singingtime' && (
                  <img
                    className='actionBtn2'
                    id='bounceIcons'
                    src={learnBtn}
                    alt='singing button'
                    onClick={() => {
                      setTouchButton(true);
                      sleep(500).then(() => {
                        openLearn();
                        setCheckStep('learn');
                      });
                    }}
                  />
                )}
              </div>
            )}

          {!displayVoice && coinIcon && !disPlayPrize && (
            <div className='actionBtnDiv'>
              {module18.reviewIcon === false && (
                <img
                  className='chooseReward'
                  id={coinAnimationState}
                  src={coinPick}
                  alt='reward key'
                  style={{
                    position: 'absolute',
                    top: '50vh',
                    left: '50vw',
                    width: '100px',
                    height: '100px',
                    marginLeft: '-50px',
                    marginTop: '-50px',
                    zIndex: 10,
                  }}
                  onClick={() => {
                    coinAnimation();
                  }}
                />
              )}
            </div>
          )}

          {!disPlayPrize &&
            !showAnimal &&
            !displayReward &&
            (
              <div className='actionBtnDiv'>
                {module18.reviewIcon && (
                <img
                  className={showReward ? 'actionBtn3' : 'actionBtn2'}
                  src={reviewBtn}
                  alt='review button'
                  onClick={() => {
                    setReviewIcon(!reviewIcon);
                  }}
                  />)}
                  {showReward && (
                    <img
                      src={rewardBtn}
                      className='actionBtn4'
                      alt='review button'
                      onClick={() => {
                        setTouchButton(true);
                        sleep(500).then(() => {
                          rewardAnimation();
                        });
                      }}
                  />)}
                {module18.reviewIcon && reviewIcon && displayReview()}
              </div>
            )}

          {!coinIcon && keyIcon && !disPlayPrize && (
            <img
              style={{ width: '80px', height: '75px' }}
              className='rewardsIcon'
              id={rewardAnimationState}
              src={fly}
              alt='reward key'
              onClick={() => {
                rewardAnimation();
              }}
            />
          )}
          {showFly && audioReady && (
            <div id='flyY'>
              <img
                style={{ width: '80px', height: '75px' }}
                className='flyPosition'
                id={'flyX'}
                src={fly}
              />
            </div>
          )}
          {displayReward && selectReward()}

          {!disPlayPrize && !coinIcon && presentIcon && (
            <img
              className='present'
              style={{
                width: '84px',
                height: '100px',
                marginLeft: '-42px',
                zIndex: 10,
              }}
              id='bounceIcons'
              src={present}
              alt='gift'
              onClick={() => {
                playSurpriseVideo();
              }}
            />
          )}
          {!disPlayPrize && !coinIcon && presentIcon && (
            <audio autoPlay>
              <source src={presentSound}></source>
            </audio>
          )}

          <div className='rewardArea'>
            {module18.rewards.LongNeckRed.unlocked && (
              <Draggable
                disabled={!displayGreenButton}
                bounds='parent'
                position={{
                  x: module18.rewards.LongNeckRed.x * clientWidth,
                  y: module18.rewards.LongNeckRed.y * clientHeight,
                }}
                onStop={(e, data) => {
                  onStop(82, data);
                }}
              >
                <div
                  className='moveLongNeckReward1'
                  style={{ backgroundImage: `url(${LongNeckRed})` }}
                ></div>
              </Draggable>
            )}

            {module18.rewards.LongNeckGreen.unlocked && (
              <Draggable
                disabled={!displayGreenButton}
                bounds='parent'
                position={{
                  x: module18.rewards.LongNeckGreen.x * clientWidth,
                  y: module18.rewards.LongNeckGreen.y * clientHeight,
                }}
                onStop={(e, data) => {
                  onStop(81, data);
                }}
              >
                <div
                  className='moveLongNeckReward2'
                  style={{ backgroundImage: `url(${LongNeckGreen})` }}
                ></div>
              </Draggable>
            )}

            {module18.rewards.PottedCactusBarrel.unlocked && (
              <Draggable
                disabled={!displayGreenButton}
                bounds='parent'
                position={{
                  x: module18.rewards.PottedCactusBarrel.x * clientWidth,
                  y: module18.rewards.PottedCactusBarrel.y * clientHeight,
                }}
                onStop={(e, data) => {
                  onStop(21, data);
                }}
              >
                <div
                  className='moveBarrelReward1'
                  style={{ backgroundImage: `url(${PottedCactusBarrel})` }}
                ></div>
              </Draggable>
            )}

            {module18.rewards.PottedCactusPrickly.unlocked && (
              <Draggable
                disabled={!displayGreenButton}
                bounds='parent'
                position={{
                  x: module18.rewards.PottedCactusPrickly.x * clientWidth,
                  y: module18.rewards.PottedCactusPrickly.y * clientHeight,
                }}
                onStop={(e, data) => {
                  onStop(22, data);
                }}
              >
                <div
                  className='moveSmallReward2'
                  style={{ backgroundImage: `url(${PottedCactusPrickly})` }}
                ></div>
              </Draggable>
            )}

            {module18.rewards.DinoFlyingGreen.unlocked && (
              <Draggable
                disabled={!displayGreenButton}
                bounds='parent'
                position={{
                  x: module18.rewards.DinoFlyingGreen.x * clientWidth,
                  y: module18.rewards.DinoFlyingGreen.y * clientHeight,
                }}
                onStop={(e, data) => {
                  onStop(31, data);
                }}
              >
                <div
                  className='moveReward1'
                  style={{ backgroundImage: `url(${DinoFlyingGreen})` }}
                ></div>
              </Draggable>
            )}

            {module18.rewards.DinoFlyingPurple.unlocked && (
              <Draggable
                disabled={!displayGreenButton}
                bounds='parent'
                position={{
                  x: module18.rewards.DinoFlyingPurple.x * clientWidth,
                  y: module18.rewards.DinoFlyingPurple.y * clientHeight,
                }}
                onStop={(e, data) => {
                  onStop(32, data);
                }}
              >
                <div
                  className='moveReward2'
                  style={{ backgroundImage: `url(${DinoFlyingPurple})` }}
                ></div>
              </Draggable>
            )}

            {module18.rewards.BackpackPurple.unlocked && (
              <Draggable
                disabled={!displayGreenButton}
                bounds='parent'
                position={{
                  x: module18.rewards.BackpackPurple.x * clientWidth,
                  y: module18.rewards.BackpackPurple.y * clientHeight,
                }}
                onStop={(e, data) => {
                  onStop(41, data);
                }}
              >
                <div
                  className='moveBackpack1'
                  style={{ backgroundImage: `url(${BackpackPurple})` }}
                ></div>
              </Draggable>
            )}

            {module18.rewards.BackpackGreen.unlocked && (
              <Draggable
                disabled={!displayGreenButton}
                bounds='parent'
                position={{
                  x: module18.rewards.BackpackGreen.x * clientWidth,
                  y: module18.rewards.BackpackGreen.y * clientHeight,
                }}
                onStop={(e, data) => {
                  onStop(42, data);
                }}
              >
                <div
                  className='moveBackpack2'
                  style={{ backgroundImage: `url(${BackpackGreen})` }}
                ></div>
              </Draggable>
            )}

            {module18.rewards.StegoBlue.unlocked && (
              <Draggable
                disabled={!displayGreenButton}
                bounds='parent'
                position={{
                  x: module18.rewards.StegoBlue.x * clientWidth,
                  y: module18.rewards.StegoBlue.y * clientHeight,
                }}
                onStop={(e, data) => {
                  onStop(51, data);
                }}
              >
                <div
                  className='moveCharaterReward17'
                  style={{ backgroundImage: `url(${StegoBlue})` }}
                ></div>
              </Draggable>
            )}

            {module18.rewards.StegoGreen.unlocked && (
              <Draggable
                disabled={!displayGreenButton}
                bounds='parent'
                position={{
                  x: module18.rewards.StegoGreen.x * clientWidth,
                  y: module18.rewards.StegoGreen.y * clientHeight,
                }}
                onStop={(e, data) => {
                  onStop(52, data);
                }}
              >
                <div
                  className='moveCharaterReward27'
                  style={{ backgroundImage: `url(${StegoGreen})` }}
                ></div>
              </Draggable>
            )}

            {module18.rewards.FossilSkull.unlocked && (
              <Draggable
                disabled={!displayGreenButton}
                bounds='parent'
                position={{
                  x: module18.rewards.FossilSkull.x * clientWidth,
                  y: module18.rewards.FossilSkull.y * clientHeight,
                }}
                onStop={(e, data) => {
                  onStop(61, data);
                }}
              >
                <div
                  className='moveCharaterReward17'
                  style={{ backgroundImage: `url(${FossilSkull})` }}
                ></div>
              </Draggable>
            )}

            {module18.rewards.FossilArm.unlocked && (
              <Draggable
                disabled={!displayGreenButton}
                bounds='parent'
                position={{
                  x: module18.rewards.FossilArm.x * clientWidth,
                  y: module18.rewards.FossilArm.y * clientHeight,
                }}
                onStop={(e, data) => {
                  onStop(62, data);
                }}
              >
                <div
                  className='moveCharaterReward27'
                  style={{ backgroundImage: `url(${FossilArm})` }}
                ></div>
              </Draggable>
            )}

            {module18.rewards.Bandanna.unlocked && (
              <Draggable
                disabled={!displayGreenButton}
                bounds='parent'
                position={{
                  x: module18.rewards.Bandanna.x * clientWidth,
                  y: module18.rewards.Bandanna.y * clientHeight,
                }}
                onStop={(e, data) => {
                  onStop(11, data);
                }}
              >
                <div
                  className='moveCharaterReward1'
                  style={{ backgroundImage: `url(${Bandanna})` }}
                ></div>
              </Draggable>
            )}

            {module18.rewards.Hat.unlocked && (
              <Draggable
                disabled={!displayGreenButton}
                bounds='parent'
                position={{
                  x: module18.rewards.Hat.x * clientWidth,
                  y: module18.rewards.Hat.y * clientHeight,
                }}
                onStop={(e, data) => {
                  onStop(12, data);
                }}
              >
                <div
                  className='moveCharaterReward2'
                  style={{ backgroundImage: `url(${Hat})` }}
                ></div>
              </Draggable>
            )}

            {module18.rewards.RaptorDark.unlocked && (
              <Draggable
                disabled={!displayGreenButton}
                bounds='parent'
                position={{
                  x: module18.rewards.RaptorDark.x * clientWidth,
                  y: module18.rewards.RaptorDark.y * clientHeight,
                }}
                onStop={(e, data) => {
                  onStop(72, data);
                }}
              >
                <div
                  className='moveReward2'
                  style={{ backgroundImage: `url(${RaptorDark})` }}
                ></div>
              </Draggable>
            )}

            {module18.rewards.RaptorLight.unlocked && (
              <Draggable
                disabled={!displayGreenButton}
                bounds='parent'
                position={{
                  x: module18.rewards.RaptorLight.x * clientWidth,
                  y: module18.rewards.RaptorLight.y * clientHeight,
                }}
                onStop={(e, data) => {
                  onStop(71, data);
                }}
              >
                <div
                  className='moveReward1'
                  style={{ backgroundImage: `url(${RaptorLight})` }}
                ></div>
              </Draggable>
            )}

            {module18.rewards.LizardBandana.unlocked && (
              <Draggable
                disabled={!displayGreenButton}
                bounds='parent'
                position={{
                  x: module18.rewards.LizardBandana.x * clientWidth,
                  y: module18.rewards.LizardBandana.y * clientHeight,
                }}
                onStop={(e, data) => {
                  onStop(1, data);
                }}
              >
                <div
                  className='moveReward1'
                  style={{ backgroundImage: `url(${LizardBandana})` }}
                ></div>
              </Draggable>
            )}

            {module18.rewards.LizardVest.unlocked && (
              <Draggable
                disabled={!displayGreenButton}
                bounds='parent'
                position={{
                  x: module18.rewards.LizardVest.x * clientWidth,
                  y: module18.rewards.LizardVest.y * clientHeight,
                }}
                onStop={(e, data) => {
                  onStop(2, data);
                }}
              >
                <div
                  className='moveReward2'
                  style={{ backgroundImage: `url(${LizardVest})` }}
                ></div>
              </Draggable>
            )}
          </div>
        </div>
      )}
    </>
  );
};
export default Module18World;
